import React from 'react';
import { NavigationDropDownItem } from '../../../../../ui/new-components/NavigationDropDownItem';
import { useUrlForPageId } from '../../../../app/pages/ui/utils/useUrlForPageId';
import { StyledSubmenu } from '../main/StyledNavigationItems';

export interface ISubMenuItemConfig {
	id: string;
	pageId: string;
	title: string;
}

interface INavigationSubMenuProps {
	subMenuItems: ISubMenuItemConfig[];
	width: string;
	className?: string;
	open: boolean;
	relativeSubMenu?: boolean;
	onItemClick?: () => void;
}

const DropDownItem = ({
	title,
	pageId,
	onClick,
}: {
	title: string;
	pageId: string;
	onClick?: () => void;
}) => {
	const href = useUrlForPageId(pageId);
	return <NavigationDropDownItem title={title} href={href} onClick={onClick} />;
};

export const NavigationSubMenu = ({
	width,
	className,
	subMenuItems,
	open,
	relativeSubMenu = false,
	onItemClick,
}: INavigationSubMenuProps) => (
	<StyledSubmenu
		className={className}
		open={open}
		role={open ? 'menu' : undefined}
		aria-hidden={!open}
		relativeSubMenu={relativeSubMenu}
		width={width}
	>
		{open &&
			subMenuItems.map((subMenuItem) => (
				<DropDownItem
					key={subMenuItem.id}
					title={subMenuItem.title}
					pageId={subMenuItem.pageId}
					onClick={onItemClick}
				/>
			))}
	</StyledSubmenu>
);
